import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { saveTokens, getUserDetails } from "../../redux/auth/authActions";
import PropTypes from "prop-types";

//Get Token Id from url
const getIdToken = (url) => {
  const getIdTokenArr = /id_token=.*access_token=.*expires_in/.exec(url);

  if (getIdTokenArr) {
    let getIdTokenArr1 = /id_token=.*access_token/.exec(url);
    return getIdTokenArr1
      ? getIdTokenArr1[0]
        .split("")
        .splice(9, getIdTokenArr1[0].length - 22)
        .join("")
      : getIdTokenArr;
  } else {
    const getIdTokenArrAcc2 = /id_token=.*token_type/.exec(url);
    return getIdTokenArrAcc2
      ? getIdTokenArrAcc2[0]
        .split("")
        .splice(9, getIdTokenArrAcc2[0].length - 20)
        .join("")
      : getIdTokenArrAcc2;
  }
};

//Get access Token from url
const getAccessToken = (url) => {
  const getAccessTokenArr = /access_token=.*expires_in=.*token_type/.exec(url);

  if (getAccessTokenArr) {
    const myArr = /access_token=.*expires_in/.exec(url);
    return myArr
      ? myArr[0]
        .split("")
        .splice(13, myArr && myArr[0].length - 24)
        .join("")
      : myArr;
  } else {
    const getIdTokenArrAcc2 = /access_token=.*id_token/.exec(url);
    return getIdTokenArrAcc2
      ? getIdTokenArrAcc2[0]
        .split("")
        .splice(13, getIdTokenArrAcc2[0].length - 22)
        .join("")
      : getIdTokenArrAcc2;
  }
};


//Function for getTokens
const getTokens = (url) => ({
  idToken: getIdToken(url),
  accessToken: getAccessToken(url),
  // expiresIn: getExpiresIn(url)
});

/**
 * The ServerReviewAuthPage Authenticate the user and save Token obj in localStorage as in Redux
 * @author shilpa.adikeshava
 * @version 1.0
 * @see Used in component: Routes.js
 */

//Function for Auth the user and save Token obj in localStorage as in Redux
const ServerReviewAuthPage = ({ history, saveTokenFunc, getUserDetails, isAuthenticated, loadingAuthentication }) => {
  const [tokensProcessed, setTokensProcessed] = useState(false);

  // Process tokens once when component mounts
  useEffect(() => {
    if (!tokensProcessed) {
      const url = window.location.href;
      const tokenObj = getTokens(url);
      localStorage.setItem("tokenObj", JSON.stringify(tokenObj));
      localStorage.setItem("token", tokenObj.idToken);
      localStorage.setItem("accessToken", tokenObj.accessToken);
      saveTokenFunc(tokenObj);
      getUserDetails(tokenObj.idToken);
      setTokensProcessed(true);
    }
  }, [tokensProcessed, saveTokenFunc, getUserDetails]);

  // Redirect only when authentication is complete
  useEffect(() => {
    if (tokensProcessed && !loadingAuthentication && isAuthenticated) {
      history.push("/serverReview");
    }
  }, [tokensProcessed, loadingAuthentication, isAuthenticated, history]);

  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex'
    }}>
      <div style={{
        width: '100%',
        height: 'calc(100dvh - 30px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <CircularProgress />
      </div>
    </div>
  );
};

ServerReviewAuthPage.propTypes = {
  /** ID Token */
  getIdToken: PropTypes.string,
  /** Access Token */
  accessToken: PropTypes.string,
  /** Function for save tokens*/
  saveTokens: PropTypes.func,
  /** Function for get user details */
  getUserDetails: PropTypes.func,
  /** Function for get tokens */
  getTokens: PropTypes.func,
  /** Authentication state */
  isAuthenticated: PropTypes.bool,
  /** Loading state */
  loadingAuthentication: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loadingAuthentication: state.auth.loadingAuthentication,
});

export default withRouter(
  connect(mapStateToProps, { saveTokenFunc: saveTokens, getUserDetails: getUserDetails })(
    ServerReviewAuthPage
  )
);
